import Column from "@amzn/meridian/column"
import Alert from "@amzn/meridian/alert"
import React from "react";
import {FormattedMessage} from "react-intl";
import Link from "@amzn/meridian/link";

const PermissionAlertBanner = () => {
    return(
        <Column>
            <Alert type="warning" size="large">
                <FormattedMessage id="banner.dmwPermission"/>
                <Link target={"_blank"} rel={"noopener noreferrer"}
                      href={"https://w.amazon.com/bin/view/DeliveryStationTech/ConveyorAutomation/DeviceManagementSCC/#HNewaccesspermissionsunderSCCDevicemanagementtabforASL2FADTA2FADTFdevices"}>
                    <FormattedMessage id="banner.permissionWiki"/>
                </Link>
            </Alert>
        </Column>
    )
}

export default PermissionAlertBanner


// WEBPACK FOOTER //
// ./src/components/commonui/PermissionAlertBanner.js